import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function compactStrings(values: unknown[]): string[] {
  return values
    .flatMap((v) => (Array.isArray(v) ? v : [v]))
    .map((v) => (typeof v === 'string' ? v.trim() : ''))
    .filter(Boolean);
}
/**
 * Defensive normalization for titles coming from external parsers/imports.
 * - Avoids JS Array->String default (comma-separated) coercion
 * - Trims and collapses whitespace
 * - Removes trailing/leading commas produced by empty fragments
 */
export function sanitizeTitle(title: unknown): string {
  const raw =
    typeof title === 'string'
      ? title
      : Array.isArray(title)
        ? title.map((x) => (typeof x === 'string' ? x : '')).join('')
        : '';

  return raw
    .replace(/\s+/g, ' ')
    .trim()
    .replace(/^\s*,\s*/, '')
    .replace(/,\s*$/, '');
}

export const truncateText = (text: string, maxLength = 500) => {
  if (!text) return '';
  return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
};
